module.exports = __webpack_public_path__ + "img/bg_08.fb34b89d.png";